// extracted by mini-css-extract-plugin
module.exports = {"List":"_3Ey-9","Item":"_15F6O","Icon":"_3-_hy","Platform":"_2YSMc","SocialMedia":"_3ilv6","Text":"_1UJ07","Content":"_37WsJ","Not":"_29cqd","Social":"MS8DA"};